/**
 * Shuffle items from the given array.
 *
 * @param  {list} as - the target array
 * @param  {columns} as - the number to split array
 *
 * @return {Array} An array of split arrays.
 */
export default function splitArray(list, columns) {
  if (!list || !columns || (list && !list.length)) return [];

  const chunk = Math.ceil(list.length / columns);
  const bigArray = [];
  for (let i = 0; i < list.length; i += chunk) {
    const array = list.slice(i, i + chunk);
    bigArray.push(array);
  }
  return bigArray;
}
